"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  quote: "Emplify.World transformed my brand with innovative strategies that doubled my engagement in just three months.",
  author: "Alex Tan",
  position: "CEO, High Tech Manufacturing",
  badge: "Brand Transformation",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589716/img/testimonial_alex_r.png"
}, {
  quote: "Thanks to their VIP program, I scaled my business significantly and gained high-profile clients.",
  author: "Samantha K.",
  position: "Entrepreneur",
  badge: "VIP Program Customer",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589716/img/testimonial_samantha_k.png"
}, {
  quote: "The clarity call alone was worth its weight in gold. The full program completely rewired my business model for high-ticket sales.",
  author: "Marcus T.",
  position: "Agency Owner",
  badge: "Strategic Growth",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589716/img/testimonial_marcus_t.png"
}];
export default function ClientSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="client-success-stories" className="bg-muted/40 py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`mx-auto max-w-3xl text-center mb-16 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-foreground mb-6 tracking-tight">
            Client Success Stories
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mx-auto">
            Real results from creative professionals who bridged the gap between
            vision and strategic success.
          </p>
        </div>

        <div className={`mx-auto max-w-5xl relative transition-all duration-1000 delay-200 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <Carousel opts={{
          loop: true,
          align: "center"
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                  <div className="p-2 md:p-6">
                    <Card className="bg-background border-none shadow-xl shadow-primary/5 rounded-[2.5rem] overflow-hidden">
                      <CardContent className="p-8 md:p-16 flex flex-col items-center text-center gap-10">
                        <Quote className="size-12 text-primary/30 rotate-180 shrink-0" />
                        
                        <p className="font-serif text-2xl md:text-4xl italic text-foreground leading-relaxed md:leading-loose">
                          "{testimonial.quote}"
                        </p>
                        
                        <div className="flex flex-col items-center gap-5 mt-4">
                          <SafeHydrate><Avatar className="size-24 border-4 border-muted shadow-sm">
                            <AvatarImage src={i === 0 ? 'https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589716/img/testimonial_asian_man.png' : testimonial.image} alt={i === 0 ? "Asian man" : testimonial.author} className="object-cover" />
                            <AvatarFallback className="font-serif text-2xl bg-primary/10 text-primary">
                              {testimonial.author.charAt(0)}
                            </AvatarFallback>
                          </Avatar></SafeHydrate>
                          
                          <div className="space-y-1">
                            <h4 className="font-bold text-xl text-foreground">
                              {testimonial.author}
                            </h4>
                            <p className="text-muted-foreground font-medium">
                              {testimonial.position}
                            </p>
                          </div>
                          
                          <Badge variant="secondary" className="mt-2 bg-primary/10 text-primary hover:bg-primary/20 border-none px-5 py-1.5 text-sm rounded-full font-semibold tracking-wide uppercase">
                            {testimonial.badge}
                          </Badge>
                        </div>
                      </CardContent>
                    </Card>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
            
            {}
            <div className="hidden md:block">
              <CarouselPrevious className="bg-background border-border text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary size-14 -left-7 shadow-lg transition-colors" />
              <CarouselNext className="bg-background border-border text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary size-14 -right-7 shadow-lg transition-colors" />
            </div>
            
            {}
            <div className="flex justify-center gap-6 mt-8 md:hidden">
              <CarouselPrevious className="relative inset-0 translate-y-0 bg-background border-border text-primary hover:bg-primary hover:text-primary-foreground size-12 shadow-md" />
              <CarouselNext className="relative inset-0 translate-y-0 bg-background border-border text-primary hover:bg-primary hover:text-primary-foreground size-12 shadow-md" />
            </div>
          </Carousel>
        </div>
      </div>
    </section>;
}